import { CardAction, GridItem } from "@innovationnorway/lighthouse-components";
import React from "react";
import { sendSiteimproveEvent } from "../../../utils/sendSiteimproveEvent";
import { useLayout } from "../../hooks/useLayout";

interface GettingStartedCardsProps {
  fastForwardUrl: string;
  projectAssistantUrl: string;
  small?: boolean;
}

export const GettingStartedCards = ({ fastForwardUrl, projectAssistantUrl, small }: GettingStartedCardsProps) => {
  const { translations } = useLayout();
  return (
    <>
      <GridItem
        spanLarge={small ? 3 : 6}
        spanMedium={small ? 3 : 6}
        spanSmall={small ? 1 : 2}
        onClick={() => sendSiteimproveEvent(`MyPage-fastForwardBeta`, "FastForwardClicked", "Fast forward selected")}
      >
        <CardAction
          role="sidekick"
          variant="secondary"
          title={translations.checkForHelp}
          lead={translations.checkForHelpDescription}
          url={fastForwardUrl}
          //icon={{ prefix: "fasr", name: "rocket" }}
        />
      </GridItem>
      <GridItem
        spanLarge={small ? 3 : 6}
        spanMedium={small ? 3 : 6}
        spanSmall={small ? 1 : 2}
        onClick={() =>
          sendSiteimproveEvent(`MyPage-applicationStartBeta`, "ProsjektHjelpenClicked", "Prosjekthjelpen selected")
        }
      >
        <CardAction
          role="sidekick"
          variant="secondary"
          title={translations.startApplicationHere}
          lead={translations.startApplicationHereDescription}
          url={projectAssistantUrl}
        />
      </GridItem>
    </>
  );
};
